import { render, staticRenderFns } from "./detail_ownership.vue?vue&type=template&id=648c58cc&scoped=true&"
import script from "./detail_ownership.vue?vue&type=script&lang=js&"
export * from "./detail_ownership.vue?vue&type=script&lang=js&"
import style0 from "./detail_ownership.vue?vue&type=style&index=0&id=648c58cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648c58cc",
  null
  
)

export default component.exports